/** @format */

import axios from "axios";
import Carousel from "react-multi-carousel";
import { useOutletContext } from "react-router-dom";
import { FilterOutlined } from "@ant-design/icons";
import React, { useEffect, useState, useCallback } from "react";

import "../../units/index";
import Balanslar from "./Balanslar";
import Suvomborlar from "./SuvOmborlar";
import "react-multi-carousel/lib/styles.css";
import Chart2 from "../../components/Chart2";
import Chart3 from "../../components/Chart3";
import Chart4 from "../../components/Chart4";
import Chart5 from "../../components/Chart5";
import Chart6 from "../../components/Chart6";
import Chart7 from "../../components/Chart7";
import Chart10 from "../../components/Chart10";
import Chart11 from "../../components/Chart11";
import { header } from "../../../../components/api/Header";
import LoadingCard from "../../../../components/loading/loadingCard";
import { getEnv } from "../../../../lib/env";

const BoshSahifa = ({ date }) => {
  const [collapsed] = useOutletContext();

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 1024, min: 464 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 8,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  // TUZATILDI: data dan obyekt sifatida foydalanilgani uchun boshlang'ich qiymat {} qilindi
  const [data, setData] = useState({});
  const [data2, setData2] = useState([]);
  const [loading, setLoading] = useState({
    loadingFirst: false,
    loadingSecond: false,
  });

  const updateLoading = (key, value) => {
    setLoading((prev) => ({ ...prev, [key]: value }));
  };

  const fetchData = useCallback(
      async (url, key, setDataFunc) => {
        updateLoading(key, true);
        try {
          const res = await axios.get(
              `${getEnv('REACT_APP_BASE_URL')}${url}?date=${date}`,
              header()
          );
          setDataFunc(res?.data);
        } catch (error) {
          console.log("Xato:", error);
        } finally {
          updateLoading(key, false);
        }
      },
      [date]
  );

  useEffect(() => {
    Promise.all([
      fetchData("/v1/republik/dashboard/charts", "loadingSecond", setData),
      fetchData("/v1/republik/dashboard/sugorish", "loadingFirst", setData2),
    ]);
  }, [fetchData]);

  let season = "novegetatsiya";
  const m = new Date(date).getMonth() + 1;

  if (m >= 4 && m <= 9) {
    season = "vegetatsiya";
  }

  // OPTIMALLASHTIRILDI: Karusel ichidagi renderlarni toza va xavfsiz qilish uchun yordamchi funksiya
  const getSuvQiymati = (id) => {
    return data?.["m"]?.[id]?.["suvi"] ?? "-";
  };

  return (
      <div className="dashboard">
        {loading.loadingFirst ? (
            <LoadingCard loading={loading.loadingFirst} heightSize={400} />
        ) : (
            <>
              <div className="data-content mt-1 bosh-sahifa">
                <Balanslar date={date} />
                <Suvomborlar date={date} />
              </div>

              <div className="data-content card3 mt-3">
                {/* TUZATILDI: data2[0] kelgandagina grafik chiziladi, crash bo'lmaydi */}
                {data2?.[0] && (
                    <div className="card statistic-card bosh-sahifa-barchart px-2">
                      <Chart11 datas={data2[0]} />
                    </div>
                )}

                {data2?.[1] && (
                    <div className="card statistic-card bosh-sahifa-barchart px-2">
                      <Chart10 season={season} datas={data2[1]} />
                    </div>
                )}
              </div>
            </>
        )}

        {/* TUZATILDI: loadingFirst o'rniga loadingSecond qo'yildi */}
        {loading.loadingSecond ? (
            <LoadingCard loading={loading.loadingSecond} heightSize={300} />
        ) : (
            <>
              <div className="mgk-box">
                <div className="data-content mt-3">
                  <div
                      className="card statistic-card px-3 pb-0"
                      style={
                        collapsed
                            ? { width: `calc(${window.innerWidth}px - 473px)` }
                            : { width: `calc(${window.innerWidth}px - 655px)` }
                      }
                  >
                    <h4 className="statics4-title">Asosiy manbalar</h4>

                    <Carousel
                        responsive={responsive}
                        infinite={true}
                        autoPlay={true}
                        containerClass="carousel-container"
                        renderArrowsWhenDisabled={true}
                        removeArrowOnDeviceType="desktop"
                        autoPlaySpeed={10000} // String o'rniga Number qilingani ma'qul
                    >
                      <div>
                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("645")} <span className="lower">sm</span>
                          </h3>
                          <p>Termiz g/p </p>
                        </div>

                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("5")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>Amu Zang n/s</p>
                        </div>
                      </div>

                      <div>
                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("67")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>QMK</p>
                        </div>

                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("110")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>ABMK</p>
                        </div>
                      </div>

                      <div>
                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("677")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>Tuyamuyun (O'ng qir.)</p>
                        </div>

                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("678")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>Tuyamuyun (Chap qir.)</p>
                        </div>
                      </div>

                      <div>
                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("679")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>Turkmandaryo</p>
                        </div>

                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("169")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>Taxiatosh G/U</p>
                        </div>
                      </div>

                      <div>
                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("208")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>Eski Tuyatortar (Jizzax)</p>
                        </div>

                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("209")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>Eski Anhor (Qashqadaryo)</p>
                        </div>
                      </div>

                      <div>
                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("240")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>Xazara g/p</p>
                        </div>

                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("308")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>KNK</p>
                        </div>
                      </div>

                      <div>
                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("312")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>SHFK</p>
                        </div>

                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("313")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>SHFK (Tojikiston)</p>
                        </div>
                      </div>

                      <div>
                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("324")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>
                            Zardaryo <span className="lower">k-l</span>.
                          </p>
                        </div>

                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("463")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>Eski boshi </p>
                        </div>
                      </div>

                      <div>
                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("464")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>KDP boshi </p>
                        </div>

                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("465")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>BАK</p>
                        </div>
                      </div>

                      <div>
                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("466")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>Kuyganyor G/U</p>
                        </div>

                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("472")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>1-2 boʼlim chegarasi </p>
                        </div>
                      </div>

                      <div>
                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("478")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>BFK (Tojikiston) </p>
                        </div>

                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("292")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>Andijon SO (chiqishi)</p>
                        </div>
                      </div>

                      <div>
                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("298")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>Savay</p>
                        </div>

                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("299")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>Andijonsoy</p>
                        </div>
                      </div>

                      <div>
                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("300")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>Shahrixonsoy</p>
                        </div>

                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("301")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>JFMK</p>
                        </div>
                      </div>

                      <div>
                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("277")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>Teshiktosh G/U</p>
                        </div>

                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("414")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>
                            Doʼstlik <span className="lower">k-l</span>.
                          </p>
                        </div>
                      </div>

                      <div>
                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("417")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>JMMK</p>
                        </div>

                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("419")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>
                            DGNS <span className="lower">n/s</span>
                          </p>
                        </div>
                      </div>

                      <div>
                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("373")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>Gʼazalkent GES chiqishi </p>
                        </div>

                        <div className="statics4-box-inner text-center">
                          <h3>
                            {getSuvQiymati("373")}{" "}
                            <span className="lower">
                          m<sup>3</sup>/s
                        </span>
                          </h3>
                          <p>Gʼazalkent GES (boshqa) </p>
                        </div>
                      </div>
                    </Carousel>
                  </div>
                </div>

                <div className="data-sug mt-3">
                  <div className="card statistic-card px-2 pt-0 d-block">
                    <h4 className="statics4-title text-center">
                  <span>
                    Sug'orilgan maydon <span className="lower">(ming.ga)</span>
                  </span>
                    </h4>

                    <ul className="lists">
                      <li className="w-100">
                        <div className="head tex justify-content-center">
                          <h3 className="text-center">
                            <FilterOutlined
                                style={{ fontSize: "18px", color: "#1BCB80" }}
                            />
                            Jami: 1 115
                          </h3>
                        </div>
                      </li>
                    </ul>

                    <ul className="lists sugorish">
                      <li>
                        <div className="head">
                          <h3>1 210</h3>
                          <p>Paxta maydoni</p>
                        </div>
                        <div
                            className="vertical-line"
                            style={{ backgroundColor: "#FF6060" }}
                        ></div>
                      </li>

                      <li>
                        <div className="head">
                          <h3>1 115</h3>
                          <p>G'alla maydoni</p>
                        </div>
                        <div
                            className="vertical-line"
                            style={{ backgroundColor: "#FF6060" }}
                        ></div>
                      </li>

                      <li>
                        <div className="head">
                          <h3>1 210</h3>
                          <p>Tomorqa va boshqa</p>
                        </div>
                        <div
                            className="vertical-line"
                            style={{ backgroundColor: "#FF6060" }}
                        ></div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* TUZATILDI: Pastki chartlar uchun ham ma'lumot borligi ehtiyotkorlik yuzasidan shartga o'raldi */}
              <div className="data-content mt-3 data-content-footer">
                {data?.["r"] && <Chart2 data={data["r"]} />}
                {data?.["re"] && <Chart7 data={data["re"]} />}
                {data?.["o"] && <Chart3 data={data["o"]} />}
                {data?.["z"] && <Chart5 data={data["z"]} />}
                {data?.["t"] && <Chart4 data={data["t"]} />}
                {data?.["q"] && <Chart6 data={data["q"]} />}
              </div>
            </>
        )}
      </div>
  );
};

export default BoshSahifa;